"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenTooltip = _interopRequireWildcard(require("@8x8/oxygen-tooltip"));

var _ValueText = _interopRequireDefault(require("../styled/ValueText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Value =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Value, _PureComponent);

  function Value() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Value);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Value)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.checkTextOverflow();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.checkTextOverflow();
    });

    _defineProperty(_assertThisInitialized(_this), "setTextOverflows", function () {
      if (!_this.labelRef.current) return false;
      return _this.labelRef.current.scrollWidth > _this.labelRef.current.clientWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "checkTextOverflow", function () {
      var showTooltipOnOverflow = _this.props.showTooltipOnOverflow;

      if (!showTooltipOnOverflow) {
        return;
      }

      _this.textOverflows = _this.setTextOverflows();
    });

    _defineProperty(_assertThisInitialized(_this), "labelRef", _react.default.createRef());

    return _this;
  }

  _createClass(Value, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          htmlFor = _this$props.htmlFor,
          required = _this$props.required,
          disabled = _this$props.disabled,
          showTooltipOnOverflow = _this$props.showTooltipOnOverflow;

      var valueElement = _react.default.createElement(_ValueText.default, {
        ref: this.labelRef,
        htmlFor: htmlFor,
        required: required,
        disabled: disabled
      }, value);

      if (showTooltipOnOverflow && this.textOverflows) {
        return _react.default.createElement(_oxygenTooltip.default, {
          title: value,
          orientation: _oxygenTooltip.directions.top,
          showOn: _oxygenTooltip.showOnTypes.hover,
          triggerRef: this.labelRef
        }, valueElement);
      }

      return valueElement;
    }
  }]);

  return Value;
}(_react.PureComponent);

exports.default = Value;

_defineProperty(Value, "propTypes", {
  htmlFor: _propTypes.default.string,
  value: _propTypes.default.node,
  required: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  showTooltipOnOverflow: _propTypes.default.bool
});

_defineProperty(Value, "defaultProps", {
  htmlFor: null,
  value: '',
  required: false,
  disabled: false,
  showTooltipOnOverflow: true
});